module.exports = __webpack_public_path__ + "static/img/img-people.3770009.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/c28/img-people.png
// module id = 9qKO
// module chunks = 0